import { HISTORICAL_PAYMENT_FLAG } from "@monorepo/constants";
import { IHistoricalPaymentSliceState } from "@monorepo/types";

export const modifyUrlForHistoricalPayment = (state: IHistoricalPaymentSliceState, url: string) => {
  const historicalPayment = state?.historicalPaymentSlice?.historical;
  if (!historicalPayment) return url;

  return `${url}${historicalPayment ? `?${HISTORICAL_PAYMENT_FLAG}` : ""}`;
};
